module.exports = __webpack_public_path__ + "img/cont-05.ea71469c.svg";